import { render, staticRenderFns } from "./payment-detail-activity.vue?vue&type=template&id=672e4c88&scoped=true"
import script from "./payment-detail-activity.vue?vue&type=script&lang=js"
export * from "./payment-detail-activity.vue?vue&type=script&lang=js"
import style0 from "./payment-detail-activity.vue?vue&type=style&index=0&id=672e4c88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672e4c88",
  null
  
)

export default component.exports